import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import Photo from '../img/n89.png'
import AuthBg from '../img/EBD428F1-DF85-4FFB-80F5-1E799D849F44.GIF'
import '../styles/auth.css'

const AuthShell = ({ children, extra, title = 'Sign up' }) => {
  useEffect(() => {
    const html = document.documentElement
    const body = document.body
    const prev = {
      htmlOverflow: html.style.overflow,
      bodyOverflow: body.style.overflow,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyWidth: body.style.width,
      bodyHeight: body.style.height,
      bodyOverscroll: body.style.overscrollBehavior
    }
    html.style.overflow = 'hidden'
    body.style.overflow = 'hidden'
    body.style.position = 'fixed'
    body.style.top = '0'
    body.style.width = '100%'
    body.style.height = '100%'
    body.style.overscrollBehavior = 'none'
    return () => {
      html.style.overflow = prev.htmlOverflow
      body.style.overflow = prev.bodyOverflow
      body.style.position = prev.bodyPosition
      body.style.top = prev.bodyTop
      body.style.width = prev.bodyWidth
      body.style.height = prev.bodyHeight
      body.style.overscrollBehavior = prev.bodyOverscroll
    }
  }, [])

  return (
    <section className="Auth">
      <Helmet>
        <title>{title}</title>
        <meta name="theme-color" content="#000000" />
      </Helmet>
      <img className="authBgGif" src={AuthBg} alt="" />
      <div className="divin">
        <div className="authLogoSlot">
          <img className="authSvg" src={Photo} alt="" />
        </div>
        <div className="authFormCenter">{children}</div>
        {extra}
      </div>
    </section>
  )
}

export default AuthShell
